var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEtapas2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 69.999,
    height: 69.999,
    viewBox: "0 0 69.999 69.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-3 {\r\n        fill: #c7d11d;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill-rule: evenodd;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_557",
    "data-name": "Rectangle 557",
    className: "cls-1",
    width: 69.999,
    height: 69.999,
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Etapas_white",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2679",
    "data-name": "Path 2679",
    className: "cls-3",
    d: "M29.554,29.55V3.591a3.6,3.6,0,0,1,3.6-3.6H66.4a3.6,3.6,0,0,1,3.6,3.6V66.4A3.6,3.6,0,0,1,66.4,70H3.6A3.6,3.6,0,0,1,0,66.4V33.147a3.6,3.6,0,0,1,3.6-3.6Zm3.5,36.946H66.4a.1.1,0,0,0,.1-.1V3.591a.1.1,0,0,0-.1-.1H33.151a.1.1,0,0,0-.1.1Zm-3.5-33.446H3.6a.1.1,0,0,0-.1.1V66.4a.1.1,0,0,0,.1.1H29.554Z",
    transform: "translate(0 0.005)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2680",
    "data-name": "Path 2680",
    className: "cls-3",
    d: "M267.474,311.457a3.6,3.6,0,0,0-3.6-3.6h-7.389a3.6,3.6,0,0,0-3.6,3.6v12.931a1.75,1.75,0,0,0,1.75,1.75h11.083a1.75,1.75,0,0,0,1.75-1.75Zm-3.5,0a.1.1,0,0,0-.1-.1h-7.389a.1.1,0,0,0-.1.1v11.182h7.583Z",
    transform: "translate(-210.406 -256.14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2681",
    "data-name": "Path 2681",
    className: "cls-3",
    d: "M318.753,47.576a3.6,3.6,0,0,0-3.6-3.6h-3.694a3.6,3.6,0,0,0-3.6,3.6v3.7a3.6,3.6,0,0,0,3.6,3.6h3.694a3.6,3.6,0,0,0,3.6-3.6Zm-3.5,0a.1.1,0,0,0-.1-.1h-3.694a.1.1,0,0,0-.1.1v3.695a.1.1,0,0,0,.1.1h3.694a.1.1,0,0,0,.1-.1V47.576Z",
    transform: "translate(-256.143 -36.591)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2682",
    "data-name": "Path 2682",
    className: "cls-3",
    d: "M230.79,47.576a3.6,3.6,0,0,0-3.6-3.6H223.5a3.6,3.6,0,0,0-3.6,3.6v3.7a3.6,3.6,0,0,0,3.6,3.6h3.694a3.6,3.6,0,0,0,3.6-3.6Zm-3.5,0a.1.1,0,0,0-.1-.1H223.5a.1.1,0,0,0-.1.1v3.695a.1.1,0,0,0,.1.1h3.694a.1.1,0,0,0,.1-.1V47.576Z",
    transform: "translate(-182.958 -36.591)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2683",
    "data-name": "Path 2683",
    className: "cls-3",
    d: "M230.79,135.538a3.6,3.6,0,0,0-3.6-3.6H223.5a3.6,3.6,0,0,0-3.6,3.6v3.694a3.6,3.6,0,0,0,3.6,3.6h3.694a3.6,3.6,0,0,0,3.6-3.6Zm-3.5,0v3.694a.1.1,0,0,1-.1.1H223.5a.1.1,0,0,1-.1-.1v-3.694a.1.1,0,0,1,.1-.1h3.694a.1.1,0,0,1,.1.1Z",
    transform: "translate(-182.958 -109.775)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2684",
    "data-name": "Path 2684",
    className: "cls-3",
    d: "M318.753,135.538a3.6,3.6,0,0,0-3.6-3.6h-3.694a3.6,3.6,0,0,0-3.6,3.6v3.694a3.6,3.6,0,0,0,3.6,3.6h3.694a3.6,3.6,0,0,0,3.6-3.6Zm-3.5,0v3.694a.1.1,0,0,1-.1.1h-3.694a.1.1,0,0,1-.1-.1v-3.694a.1.1,0,0,1,.1-.1h3.694a.1.1,0,0,1,.1.1Z",
    transform: "translate(-256.143 -109.775)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2685",
    "data-name": "Path 2685",
    className: "cls-3",
    d: "M230.79,223.5a3.6,3.6,0,0,0-3.6-3.6H223.5a3.6,3.6,0,0,0-3.6,3.6V227.2a3.6,3.6,0,0,0,3.6,3.6h3.694a3.6,3.6,0,0,0,3.6-3.6Zm-3.5,0a.1.1,0,0,0-.1-.1H223.5a.1.1,0,0,0-.1.1V227.2a.1.1,0,0,0,.1.1h3.694a.1.1,0,0,0,.1-.1Z",
    transform: "translate(-182.958 -182.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2686",
    "data-name": "Path 2686",
    className: "cls-3",
    d: "M318.753,223.5a3.6,3.6,0,0,0-3.6-3.6h-3.694a3.6,3.6,0,0,0-3.6,3.6V227.2a3.6,3.6,0,0,0,3.6,3.6h3.694a3.6,3.6,0,0,0,3.6-3.6Zm-3.5,0V227.2a.1.1,0,0,1-.1.1h-3.694a.1.1,0,0,1-.1-.1V223.5a.1.1,0,0,1,.1-.1h3.694a.1.1,0,0,1,.1.1Z",
    transform: "translate(-256.143 -182.961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2687",
    "data-name": "Path 2687",
    className: "cls-3",
    d: "M62.254,223.5a3.6,3.6,0,0,0-3.6-3.6H47.573a3.6,3.6,0,0,0-3.6,3.6V227.2a3.6,3.6,0,0,0,3.6,3.6H58.656a3.6,3.6,0,0,0,3.6-3.6Zm-3.5,0V227.2a.1.1,0,0,1-.1.1H47.573a.1.1,0,0,1-.1-.1V223.5a.1.1,0,0,1,.1-.1H58.656a.1.1,0,0,1,.1.1Z",
    transform: "translate(-36.588 -182.96)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2688",
    "data-name": "Path 2688",
    className: "cls-3",
    d: "M62.254,311.464a3.6,3.6,0,0,0-3.6-3.6H47.573a3.6,3.6,0,0,0-3.6,3.6v3.694a3.6,3.6,0,0,0,3.6,3.6H58.657a3.6,3.6,0,0,0,3.6-3.6Zm-3.5,0v3.694a.1.1,0,0,1-.1.1H47.573a.1.1,0,0,1-.1-.1v-3.694a.1.1,0,0,1,.1-.1H58.657a.1.1,0,0,1,.1.1Z",
    transform: "translate(-36.588 -256.146)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtapas2);
export default __webpack_public_path__ + "static/media/Etapas2.e283baed4887ff451213f76469fa555f.svg";
export { ForwardRef as ReactComponent };